import { render } from "./Disciplinary_Cases.vue?vue&type=template&id=c220a6d6"
import script from "./Disciplinary_Cases.vue?vue&type=script&lang=js"
export * from "./Disciplinary_Cases.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__